import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable, map, BehaviorSubject, ReplaySubject, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestHistoryRowDataI } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class CustomerSatisfactionReportService {

  public emitSelectedReqHistorySource: Subject<RequestHistoryRowDataI> = new Subject();
  public emitSelectedReqHistoryRecord$: Observable<RequestHistoryRowDataI> = this.emitSelectedReqHistorySource.asObservable();
  public selectedTicketRequestRow!: RequestHistoryRowDataI;
  public selectedRequestSubject: Subject<RequestHistoryRowDataI> = new Subject();
  private selectedTicketResponseSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
  public dataLoaded = false;
  deleteFeedbackModal = new BehaviorSubject<any>(null);

    private apiServiceUrl = environment.apiUrl;
    private lastLoadedRequestId: string | null = null;
    private cachedResponses: { [key: string]: Observable<any> } = {};

    constructor(private http: HttpClient) {}
    public validate(clientName: string, file: File,emailId:any,notify:any,submitterName:any): Observable<any> {
        const formData: FormData = new FormData()
        formData.append('clientName', clientName)
        formData.append('multipartFile', file, file.name)
        formData.append('emailId', emailId);
        formData.append('notify', notify);
        formData.append('submitter', submitterName);
        const url = `${this.apiServiceUrl}/aipo/integration/api/sentiment/validate`
        return this.http.post(url, formData)
    }

    public SubmitNewReport(clientName: string, file: File,emailId:any,notify:any,submitterName:any): Observable<any> {
        const formData: FormData = new FormData()
        formData.append('clientName', clientName)
        formData.append('multipartFile', file, file.name)
        formData.append('emailId', emailId);
        formData.append('notify', notify);
        formData.append('submitter', submitterName);

        const url = `${this.apiServiceUrl}/aipo/integration/api/sentiment/submit`
        return this.http.post(url, formData)
    }

    public getAllReportRequests(): Observable<any> {
      const url = `${this.apiServiceUrl}/aipo/integration/api/sentiment/allRequestId`;

      return this.http.get(url).pipe(
        map((response: any) => {
            return response;
        })
      );
    }

    /**
	 * this will emit the selected request history
	 * @param {RequestHistoryRowDataI} record
	 * @memberof RequestHistoryService
	 */
    public emitSelectedRequestHistory(record: RequestHistoryRowDataI): void {
      this.emitSelectedReqHistorySource.next(record);
  }

  public setSelectedTestDesignRow(row: RequestHistoryRowDataI):Observable<any> | void  {
    this.selectedTicketRequestRow = row;
    this.selectedRequestSubject.next(row);

    if (row && row.requestId) {
      this.getSelectedReportDetails(row.requestId).subscribe((res: any) => {
        this.selectedTicketResponseSubject.next(res);
      });
    }
  }

  public getSelectedReportDetails(requestId: string): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/integration/api/sentiment/reports?requestId=${requestId}`;
    return this.http.get(url).pipe(
        map((response: any) => response));
  }

  public getSelectedTicketResponse(): Observable<any> {
    return this.selectedTicketResponseSubject.asObservable();
  }

  public getSelectedRequest() {
		return this.selectedTicketRequestRow;
	}

  public deleteFeedback(requestId: any): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/integration/api/sentiment/delete?requestId=${requestId}`;
    return this.http.delete(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}
